import styled from "styled-components"

export const Main = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 79px;
`

export const Wrapper = styled.div`
  width: 83.3%;
  height: 100%;
  display: flex;
  flex-direction: column;

  @media (max-width: 1149px) {
    width: 82.5%;
  }

  @media (max-width: 799px) {
    width: 88.88%;
  }
`

export const TitleBox = styled.div`
  width: 100%;
  height: 35px;
  display: flex;
  align-items: center;

  img {
    width: 26.67px;
    height: 30px;
  }

  h3 {
    margin-left: 14.67px;
    font-weight: 700;
    font-size: 2.3rem;
    line-height: 3.5rem;
    letter-spacing: 0.06em;
    background: linear-gradient(
      90deg,
      #ce9638 5.35%,
      #eae69c 17.05%,
      #b6872d 114.34%
    );
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }
`

export const ContentBox = styled.div`
  width: 100%;
  display: flex;
  gap: 150px;
  margin-top: 20px;

  @media (max-width: 799px) {
    flex-direction: column;
    justify-content: flex-start;
    gap: 50px;
  }
`

export const Box1 = styled.div`
  display: flex;
  flex-direction: column;
  width: 300px;

  @media (max-width: 1149px) {
    margin-top: 20px;
  }

  h5 {
    font-weight: 700;
    font-size: 1.4rem;
    line-height: 2.1rem;
    letter-spacing: 0.06em;
    color: #fdfdfd;
  }

  p {
    font-weight: 400;
    font-size: 1.4rem;
    line-height: 2.1rem;
    letter-spacing: 0.06em;
    color: #fdfdfd;

    &:nth-of-type(1),
    &:nth-of-type(2) {
      margin-top: 20px;
    }
  }

  @media (max-width: 1149px) {
    display: unset;
    flex-direction: unset;

    h5 {
      display: inline-block;
    }

    p {
      &:nth-of-type(1) {
        margin: 0;
      }
      &:nth-of-type(2) {
        margin-top: 20px;
        display: inline-block;
      }
      &:nth-of-type(3) {
        margin-top: 20px;
        display: inline-block;
        margin-left: 10px;
      }
    }
  }

  @media (max-width: 799px) {
    display: flex;
    flex-direction: column;
    p {
      &:nth-of-type(1) {
        margin-top: 20px;
      }
      &:nth-of-type(3) {
        margin-left: 0;
      }
    }
  }
`

export const Box2 = styled.div`
  display: flex;
  flex-direction: column;

  h5 {
    font-weight: 700;
    font-size: 1.4rem;
    line-height: 2.1rem;
    letter-spacing: 0.06em;
    color: #fdfdfd;
  }

  p {
    font-weight: 400;
    font-size: 1.4rem;
    line-height: 2.1rem;
    letter-spacing: 0.06em;
    color: #fdfdfd;
  }

  @media (max-width: 1149px) {
    margin-top: 0;
  }

  p {
    &:nth-of-type(1) {
      margin-top: 20px;
    }
    &:nth-of-type(3) {
      margin-top: 20px;
    }
    @media (max-width: 1149px) {
      &:nth-of-type(1) {
        margin-top: 20px;
      }
    }

    @media (max-width: 799px) {
      &:nth-of-type(1) {
        margin-top: 20px;
      }
    }
  }
`

export const Box3 = styled.div`
  display: flex;
  flex-direction: column;
  border-left: 1px solid #fdfdfd;

  h5 {
    font-weight: 700;
    font-size: 1.4rem;
    line-height: 2.1rem;
    letter-spacing: 0.06em;
    color: #fdfdfd;
  }

  p {
    font-weight: 400;
    font-size: 1.4rem;
    line-height: 2.1rem;
    letter-spacing: 0.06em;
    color: #fdfdfd;
  }

  p,
  h5 {
    margin-left: 85px;
  }

  p {
    &:nth-of-type(1) {
      margin-top: 20px;
    }
    &:nth-of-type(3) {
      margin-top: 20px;
    }
  }

  @media (max-width: 1149px) {
    margin-top: 0;
    border-left: none;

    margin-left: 100px;
    p,
    h5 {
      margin-left: 0;
    }

    p {
      &:nth-of-type(1) {
        margin-top: 20px;
      }
    }
  }

  @media (max-width: 799px) {
    margin-left: 0;

    p {
      &:nth-of-type(1) {
        margin-top: 20px;
      }
    }
  }
`

export const TabletMain = styled(Main)`
  background: #111111;
  margin-top: 55px;
`

export const TabletWrapper = styled(Wrapper)`
  padding: 30px 0;
  flex-direction: row;
`
